import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import {
  STATUS_OK,
  STATUS_NOT_FOUND,
  STATUS_SERVER_ERROR,
} from '../../constants'

const Status = ({ children, status }) => (
  <Route
    render={({ staticContext }) => {
      if (staticContext) {
        staticContext.status = status
      }

      return children
    }}
  />
)

Status.propTypes = {
  children: PropTypes.node.isRequired,
  status: PropTypes.oneOf([STATUS_OK, STATUS_NOT_FOUND, STATUS_SERVER_ERROR]),
}

export default Status
